/**
 * How a column picker names a column. The backend-injected `id` holds the device identifier, so it
 * is shown under the project's serial key label with the raw field name kept alongside, since rules
 * and exports are written against the field name.
 */
export const columnPickerLabel = (columnName: string, serialKeyLabel: string): string =>
	columnName === 'id' ? `${serialKeyLabel} (id)` : columnName
